export default __webpack_public_path__ + "static/media/PAN.a533de2e.svg";